'use client';

import mixpanel from 'mixpanel-browser';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '../constants/mixpanel-events';
import { tabStorage } from './tab-storage';

export function emitMixpanelEvent(
	eventName: (typeof mixpanelEvents)[keyof typeof mixpanelEvents],
	options: {
		feature: MIXPANEL_APP_FEATURES;
		[key: string]: string | number | boolean | undefined | unknown;
	}
) {
	try {
		// Attach the active workspace (per-tab, from window.name — see tab-storage) to every
		// event. Read at emit time rather than registered as a super property so parallel tabs
		// on different workspaces each report their own context instead of a shared value.
		const workspaceId = tabStorage.get('selectedWorkspaceId');
		const workspaceHandle = tabStorage.get('workspaceHandle');

		mixpanel.track(eventName, {
			...options,
			...(workspaceId ? { workspace_id: workspaceId } : {}),
			...(workspaceHandle ? { workspace_handle: workspaceHandle } : {}),
		});
	} catch (error) {
		console.error('Error emitting mixpanel event', error);
	}
}

export function identifyUserAndSetEmailOnMixpanel({
	email,
	name,
	planType,
}: {
	name: string;
	email: string;
	planType?: string;
}) {
	try {
		mixpanel.identify(email);
		mixpanel.people.set({ $distinct_id: email });
		mixpanel.people.set({
			$email: email ?? `email not found for user: ${name}`,
		});
		mixpanel.people.set({ name: name });
		if (planType !== undefined) {
			mixpanel.people.set({ plan_type: planType });
			mixpanel.register({ plan_type: planType });
		}
	} catch (error) {
		console.error('Error identifying user and setting email on mixpanel', error);
	}
}

export function resetMixpanel() {
	try {
		mixpanel.reset();
	} catch (error) {
		console.error('Error resetting mixpanel', error);
	}
}
